import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/siteData";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="section-pad relative bg-[hsl(225,22%,4%)]">
      <div className="container-site">
        <div className="mb-10 sm:mb-14">
          <p className="kicker mb-3">Client words</p>
          <h2 className="font-display uppercase text-foreground text-[clamp(2rem,5vw,4rem)] leading-[0.95]">
            What partners say.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={`${t.name}-${i}`}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="relative rounded-2xl border border-border bg-card p-8 sm:p-10"
            >
              <Quote className="h-7 w-7 text-[hsl(var(--primary))] mb-6" />
              <blockquote className="text-base sm:text-lg leading-relaxed text-foreground/95">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-6 border-t border-border">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[hsl(225,16%,14%)] border border-border font-display text-[hsl(var(--primary))]">
                  {t.name.split(" ").map(s => s[0]).slice(0,2).join("")}
                </span>
                <span>
                  <span className="block text-sm text-foreground">{t.name}</span>
                  <span className="block text-xs uppercase tracking-[0.18em] text-muted-foreground mt-0.5">{t.role}{t.company ? ` · ${t.company}` : ""}</span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
